export const optInResults = Object.freeze({
  0: 'UNDEFINED',
  1: 'OK',
  2: 'ERROR',
});

export default {};
